import { ProfileType } from "misc/profileHelpers";
import polyglotI18nProvider from "ra-i18n-polyglot";

import germanMessages from "./de";
import englishMessages from "./en";
import spanishMessages from "./es";
import frenchMessages from "./fr";

export const allMessages = {
  de: germanMessages,
  en: englishMessages,
  fr: frenchMessages,
  es: spanishMessages,
};

export function selectMessages(locale: string) {
  const messages = allMessages[locale as keyof typeof allMessages];
  const shipped: Record<string, unknown> = messages;
  const overrides = typeof edmTranslations === "undefined" ? {} : edmTranslations;

  // Polyglot flattens nested messages into dotted keys, so spreading the flat
  // customer overrides on top is enough. An override that names a shipped
  // section instead of a single text would replace that whole subtree.
  const flatOverrides = Object.fromEntries(
    Object.entries(overrides[locale] || {}).filter(
      ([key, text]) => typeof text === "string" && typeof shipped[key] !== "object",
    ),
  );

  return { ...messages, ...flatOverrides };
}

export function getProfileLanguage() {
  const storedProfile = localStorage.getItem("profile");
  let parsedProfile = undefined;

  if (storedProfile) {
    parsedProfile = JSON.parse(storedProfile) as ProfileType;
  }

  return parsedProfile?.language || "de";
}

export default polyglotI18nProvider(selectMessages, getProfileLanguage(), [
  { locale: "de", name: "Deutsch" },
  { locale: "en", name: "English" },
]);
